{"schemaVersion":1,"release":{"version":"1.1.2","build":164,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.2-164.dmg","sha256":"937524f3f9ec26d18746e18a7c2d03d963e1c18fa9bdf93ac8b63d03e39233c5","size":29207133}}
